import store from "@/store";

const routes = [{
    path: "/sales/items/:id",
    name: "salesitems",
    component: () => import('@/views/main/modules/Sales/Items/ItemGroupComponent'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Items',
    }
}]

export default routes;
